export default "__VITE_PUBLIC_ASSET__b2eea108__"